export interface ViagemDestino {
  readonly id: string;
  readonly mapa: string;
  readonly x: number;
  readonly y: number;
  readonly pontos: readonly { x: number; y: number }[];
  readonly rotulo: string;
  /** Aba do Teleportar: `cidade` (Cidades) ou `local` (Locais). Sem tipo, é local. */
  readonly tipo: 'cidade' | 'local';
  /** Sem guarda no mapa = sem proteção contra PK. Só é `true` quando o servidor diz que não tem. */
  readonly semGuarda: boolean;
  /** Teleportar → Minha casa (techspec-casas §02.7): o servidor resolve o destino pela conta, o cliente manda só `casa`. */
  readonly casa?: boolean;
}

export const DESTINO_CASA = 'casa';

/** A linha "Minha casa" do Teleportar: a soleira do lote. */
export function destinoDaCasa(c: { mapa: string; soleiraX: number; soleiraY: number }): ViagemDestino {
  const p = { x: c.soleiraX, y: c.soleiraY };
  return { id: DESTINO_CASA, mapa: c.mapa, x: p.x, y: p.y, pontos: [p], rotulo: 'hud.viajar.minhaCasa', tipo: 'cidade', semGuarda: false, casa: true };
}

export function pontoDaViagem(destino: ViagemDestino): { x: number; y: number } {
  const lista = destino.pontos.length > 0 ? destino.pontos : [{ x: destino.x, y: destino.y }];
  return lista[Math.floor(Math.random() * lista.length)]!;
}

const ID_OK = /^[a-z0-9-]+$/;
const VAZIO: readonly ViagemDestino[] = [];

let cacheEtag = '';
let cache: readonly ViagemDestino[] = VAZIO;

/** Lista central do menu Teleportar. Não é o portal do mapa. */
export async function carregarViagens(sinal?: AbortSignal): Promise<readonly ViagemDestino[]> {
  const { api } = await import('../api');
  const { etagAtual } = await import('../data/mundoSync');
  const etag = etagAtual() || '1-00000000';
  if (etag === cacheEtag) return cache;
  try {
    const lista = await api.viagensDoMundo(etag);
    if (sinal?.aborted) return cache;
    const out: ViagemDestino[] = [];
    for (const v of lista) {
      if (!v.id || !ID_OK.test(v.id) || !ID_OK.test(v.mapa)) continue;
      const pontos = (v.pontos ?? [])
        .filter(p => Number.isFinite(p.x) && Number.isFinite(p.y))
        .map(p => ({ x: p.x | 0, y: p.y | 0 }));
      const lista = pontos.length > 0 ? pontos : [{ x: v.x | 0, y: v.y | 0 }];
      out.push({
        id: v.id,
        mapa: v.mapa,
        x: lista[0].x,
        y: lista[0].y,
        pontos: lista,
        rotulo: v.rotulo || v.mapa,
        tipo: v.tipo === 'cidade' ? 'cidade' : 'local',
        semGuarda: v.guardas === false
      });
    }
    cacheEtag = etag;
    cache = out;
    return out;
  } catch {
    return cache;
  }
}
